export default {
  contained: {
    margin: '5px 0px 0px 0px',
    fontSize: 10,
    marginLeft: 0,
  },
};
